import {requestAsk} from '../baseRequest'

export const checkValidationCode = (config = {}) => {
  let url = 'membership/checkValidationCode'
  return requestAsk('https', 'form', url, config)
}

export const getApiToken = (token) => {
  let url = 'sso/loginAuth?token=' + token
  return requestAsk('https', 'form', url)
}

export const login = (config = {}) => {
  let url = 'user/login'
  return requestAsk('https', 'form', url, config)
}

export const logout = (config = {}) => {
  let url = 'membership/logout'
  return requestAsk('https', 'form', url, config, {}, 'GET')
}



// WEBPACK FOOTER //
// ./src/utils/api/login.js